
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refund/calculator",
      function () {
        return require("private-next-pages/refund/calculator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refund/calculator"])
      });
    }
  